import React, { useCallback, useContext, useMemo, useState } from "react";
import useBreadcrumbs from "../../../utils/hooks/useBreadcrumbs";
import { FaUserFriends } from "react-icons/fa";
import Table from "../../../UI/Table/Table";
import { PaginationType } from "../../../Types/APITypes";
import Alert from "../../../UI/Alert/Alert";
import { NotifyContext } from "../../../context/notifyContext";
import { Link } from "react-router-dom";
import ParentAPI from "../../../services/api/ParentService";
import { BsEyeFill } from "react-icons/bs";

export default function ParentList() {
  useBreadcrumbs([
    { label: "Parents", icon: <FaUserFriends />, is_link: true, href: "/app/parents" },
    { label: "Liste", is_link: false },
  ]);

  const notify = useContext(NotifyContext);
  const [error, setError] = useState("");
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [tableInfos, setTableInfos] = useState({ pageCount: 0, total: 0 });

  const fetchData = useCallback(
    (pagination?: PaginationType) => {
      setLoading(true);
      ParentAPI.get_parents(pagination)
        .then((response: any) => response?.data)
        .then((res: any) => {
          setData(res?.parents || []);
          setTableInfos({
            pageCount: res?.last_page || 1,
            total: res?.total || 0,
          });
          setError("");
        })
        .catch((err: any) => {
          setError(err?.message || err || "Erreur");
          notify(err?.message || err, "error");
        })
        .finally(() => setLoading(false));
    },
    [notify]
  );

  const columns = useMemo(
    () => [
      {
        Header: "Date",
        Cell: (params: any) => {
          const row = params.row?.original;
          return (
            <p>
              {row?.created_at
                ? new Date(row.created_at).toISOString().replace("T", " ").split(".")[0]
                : "-"}
            </p>
          );
        },
      },
      {
        Header: "Nom",
        Cell: (params: any) => {
          const row = params.row?.original;
          return (
            <p>
              {row?.first_name} {row?.last_name}
            </p>
          );
        },
      },
      { Header: "Email", accessor: "email" },
      { Header: "Téléphone", accessor: "phone_number" },
      {
        Header: "Statut",
        Cell: (params: any) => {
          const row = params.row?.original;
          const status = row?.user_status || "-";
          return <span className="capitalize">{status}</span>;
        },
      },
      {
        Header: "Action",
        Cell: (params: any) => {
          const row = params.row?.original;
          return (
            <Link
              className="text-primary-900 flex items-center gap-2"
              to={`/app/parents/${row?.id}/view`}
            >
              <BsEyeFill /> Voir
            </Link>
          );
        },
      },
    ],
    []
  );

  React.useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="flex flex-col overflow-auto">
      <div className="flex flex-col flex-1">
        {error && <Alert color="error">{error}</Alert>}
        {loading && tableInfos.total === 0 && (
          <div className="flex justify-center w-full p-8">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600" />
          </div>
        )}
        {tableInfos.total === 0 && !loading && (
          <div className="flex flex-col items-center justify-center gap-4 p-8 border border-dashed rounded border-black/60">
            <p>Aucun parent inscrit</p>
          </div>
        )}
        <div className="flex flex-1">
          <Table
            columns={columns}
            data={data}
            fetchData={fetchData}
            loading={loading}
            pageCount={tableInfos.pageCount}
            total={tableInfos.total}
            className="flex-1"
          />
        </div>
      </div>
    </div>
  );
}
